import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import DeviceService from "src/service/device";
import swal from "sweetalert";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { IconArrowBack } from "@tabler/icons";
import DeviceModelService from "src/service/devicemodel";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Device",
  },
];

const validationSchema = yup.object({
  no_of_device: yup
    .string("Enter No of Devices")
    .matches(/^[0-9]{1,2}$/, "Invalid No of Devices")
    .required("No of Devices is Required"),

  manufacturing_date_time: yup
    .string("Enter Date")
    .required("Manufacuring Date is Required"),

  make: yup
    .string("Enter Make")
    .min(2, "Make should be at least 2 character long")
    .max(30, "Make should not exceed 30 character")
    .required("Make is Required"),

  model_id: yup.string("Select Model Name").required("Model Name is Required"),
});

const AddDevice = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [deviceModel, setdeviceModel] = React.useState("");
  const [devicemodel_name, setDeviceModel_name] = useState([]);
  // const [selectedDevice, setSelectedDevice] = useState("");
  const [dynamicFields, setDynamicFields] = useState([]);
  const [isDynamicFieldsUpdated, setDynamicFieldsUpdated] = useState(false);

  const handleNoOfDevicesChange = (event) => {
    const noOfDevices = parseInt(event.target.value, 10) || 0;
    const newFields = Array.from({ length: noOfDevices }, (_, index) => ({
      id: index,
      imei_no: "",
      serial_no: "",
      device_type: "",
    }));
    setDynamicFields(newFields);
  };

  const fetchDeviceModelData = async () => {
    try {
      const res = await DeviceModelService.getDeviceModel({
        manufacturer_id: sessionData.data.id,
      });
      setDeviceModel_name(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const device_type_list = [
    {
      value: "1",
      label: "GPS",
    },
    {
      value: "2",
      label: "SOS Button",
    },
    {
      value: "3",
      label: "GPS with SOS Button",
    },
  ];

  const initialValues = {
    manufacturer_id: sessionData.data.id,
    no_of_device: "",
    make: "",
    model_id: "",
    manufacturing_date_time: "",
    c_by: sessionData.data.id,
    device_data: [],
  };

  const handleChangeDynamicField = (fieldId, fieldName, fieldValue) => {
    const updatedFields = dynamicFields.map((field) =>
      field.id === fieldId ? { ...field, [fieldName]: fieldValue } : field
    );
    setDynamicFields(updatedFields);

    // Update formik values with the new dynamic field value
    // setFieldValue(`${fieldName}_${fieldId}`, fieldValue);
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async () => {
      // Extract device data from dynamicFields
      const deviceData = dynamicFields.map((field) => ({
        imei_no: field.imei_no,
        serial_no: field.serial_no,
        device_type: field.device_type,
      }));

      // Update the formik values with the device_data array
      setFieldValue("device_data", deviceData);

      // Use a state to track whether the dynamic fields are updated

      // Update the dynamicFields state
      setDynamicFields((prevFields) => {
        const newFields = Array.from(
          { length: values.no_of_device },
          (_, index) => ({
            id: index,
            imei_no: "",
            serial_no: "",
            device_type: "",
          })
        );
        setDynamicFieldsUpdated(true);
        return newFields;
      });

      // useEffect to submit the form after dynamicFields state is updated
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      if (isDynamicFieldsUpdated) {
        // You can now use the updated values in your API call
        try {
          const res = await DeviceService.addDevice(values);

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/device");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      }
    };

    fetchData(); // Call the async function immediately
  }, [isDynamicFieldsUpdated, navigate, values]);

  useEffect(() => {
    fetchDeviceModelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  return (
    <div>
      <Breadcrumb title="Add Device" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Register Device
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/device");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "0px" }}>
            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="model_id">
                Model Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <Autocomplete
                id="model_id"
                name="model_id"
                options={devicemodel_name}
                // getOptionLabel={(option) => option.driver_name}
                getOptionLabel={(option) => `${option.model_name}`}
                value={
                  devicemodel_name.find(
                    (model) => model.id === values.model_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "model_id", value: newValue?.id || "" },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.model_id && Boolean(errors.model_id)}
                    helperText={touched.model_id && errors.model_id}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a model"
                  />
                )}
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="make">
                Make <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="make"
                name="make"
                type="text"
                value={values.make}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.make && Boolean(errors.make)}
                helperText={touched.make && errors.make}
                variant="outlined"
                placeholder="Enter Make"
                fullWidth
              />
            </Grid>
            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="manufacturing_date_time">
                Manufacturing Date <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="manufacturing_date_time"
                name="manufacturing_date_time"
                type="date"
                value={values.manufacturing_date_time}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.manufacturing_date_time &&
                  Boolean(errors.manufacturing_date_time)
                }
                helperText={
                  touched.manufacturing_date_time &&
                  errors.manufacturing_date_time
                }
                variant="outlined"
                placeholder="Enter Manufacturing Date"
                fullWidth
              />
            </Grid>
            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="no_of_device">
                No of Device <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="no_of_device"
                name="no_of_device"
                type="number"
                value={values.no_of_device}
                onChange={(event) => {
                  handleNoOfDevicesChange(event);
                  handleChange(event);
                }}
                onBlur={handleBlur}
                error={touched.no_of_device && Boolean(errors.no_of_device)}
                helperText={touched.no_of_device && errors.no_of_device}
                variant="outlined"
                placeholder="Enter No of Devices"
                fullWidth
              />
            </Grid>

            {/* Render dynamic fields */}
            {dynamicFields.map((field) => (
              <React.Fragment key={field.id}>
                <Grid
                  item
                  lg={4}
                  md={12}
                  sm={12}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor={`imei_no_${field.id}`}>
                    IMEI No <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id={`imei_no_${field.id}`}
                    name={`imei_no_${field.id}`}
                    type="text"
                    value={values[`imei_no_${field.id}`]}
                    onChange={(e) =>
                      handleChangeDynamicField(
                        field.id,
                        "imei_no",
                        e.target.value
                      )
                    }
                    onBlur={handleBlur}
                    error={touched.imei_no && Boolean(errors.imei_no)}
                    helperText={touched.imei_no && errors.imei_no}
                    variant="outlined"
                    placeholder="Enter IMEI No"
                    fullWidth
                    inputProps={{ maxLength: 15, minLength: 15 }}
                  />
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={12}
                  sm={12}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor={`serial_no_${field.id}`}>
                    Serial No <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id={`serial_no_${field.id}`}
                    name={`serial_no_${field.id}`}
                    type="text"
                    value={values[`serial_no_${field.id}`]}
                    onChange={(e) =>
                      handleChangeDynamicField(
                        field.id,
                        "serial_no",
                        e.target.value
                      )
                    }
                    onBlur={handleBlur}
                    variant="outlined"
                    placeholder="Enter Serial No"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={12}
                  sm={12}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor={`device_type_${field.id}`}>
                    Device Type <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomSelect
                    id={`device_type_${field.id}`}
                    name={`device_type_${field.id}`}
                    value={values[`device_type_${field.id}`]}
                    onChange={(e) =>
                      handleChangeDynamicField(
                        field.id,
                        "device_type",
                        e.target.value
                      )
                    }
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                  >
                    <MenuItem value="">Select Device Type</MenuItem>
                    {device_type_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
          <Grid item lg={6} md={12} sm={12} style={{ marginTop: "20px" }}>
            <Button color="primary" variant="contained" type="submit">
              Submit
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddDevice;
